import React from 'react';
import Reflux from 'reflux';
import Modal from 'shared/components/misc/modal.jsx';
import UIRegions from 'shared/constants/UIRegions';
import { Button } from 'bootstrap';
import { Map } from 'immutable';
import ModalHelper from './modalHelper';
import { EditableCellTypes } from 'flux/stores/cuesheet/CuesheetConstants';
import UserSessionStore from 'flux/stores/UserSessionStore';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import ModalActions from 'flux/actions/ModalActions';
import RTE from 'shared/components/rte/rte.jsx';

export default React.createClass({
  mixins: [
    Reflux.connectFilter(UserSessionStore, 'userId', (state) =>
      state.get('_id'),
    ),
    Reflux.connectFilter(
      CuesheetStore,
      'rowState',
      ModalHelper.itemConnectFilter(
        (row) => row.getIn(['editing', 'type']) === EditableCellTypes.ItemNote,
      ),
    ),
  ],

  displayName: 'NoteModal',

  render() {
    let { rowState } = this.state;

    if (!rowState) return null;

    return (
      <Modal
        className="csr-modal-item-title-wrapper"
        name={this._getModalId()}
        onHide={() => CuesheetCellActions.cancelEditing()}
        title="Note"
      >
        <div className="csr-modal-item-title-content">
          {this._getInputNode()}
          <Button onClick={this._handleDone}>Save</Button>
        </div>
      </Modal>
    );
  },

  _getInputNode() {
    return (
      <RTE
        ref="rteNote"
        displayToolbar={false}
        readOnly={false}
        rteState={this._getCellText()}
        autoFocus
        disableBlur
      />
    );
  },

  _getUserSettings() {
    let { item } = this.state.rowState;
    return item.get('userSettings');
  },

  _getCellText() {
    let { userId } = this.state;

    let userSettings = this._getUserSettings();
    let path = [userId, 'note', 'rteState'];

    if (userSettings && userSettings.getIn(path)) {
      return userSettings.getIn(path);
    }

    return '';
  },

  _handleDone() {
    const rteState = this.refs.rteNote.getValue();

    const cellSpec = Map({
      type: EditableCellTypes.ItemNote,
      value: EditableCellTypes.ItemNote,
    });

    CuesheetCellActions.saveDataCellChanges(
      this.state.rowState.rowId,
      cellSpec,
      rteState,
    );

    ModalActions.hide(this._getModalId());
  },

  _getModalId() {
    return UIRegions.CuesheetItemNote;
  },

  componentDidUpdate() {
    if (this.state.rowState) {
      ModalActions.show(this._getModalId());
    }
  },
});
